import { Component, inject, OnInit } from '@angular/core';
import { DestroyBase } from '../../../../shared/base-classes/destroy-component-base';
import { OutreachService } from '../../services/outreach.service';
import { ActivatedRoute } from '@angular/router';
import {
  OutreachFormData,
  OutreachFormType,
} from '../../models/outreach-form-data';
import { CRFOutreachFormComponent } from '../crf-outreach-form/crf-outreach-form.component';
import { Connection } from '../../models/connection.model';
import { isValidGUID } from '../../../../shared/utils/utils';
import { GeneralOutreachFormV2Component } from '../general-outreach-form-v2/general-outreach-form-v2.component';
import { takeUntil } from 'rxjs';

@Component({
  selector: 'app-outreach',
  standalone: true,
  imports: [CRFOutreachFormComponent, GeneralOutreachFormV2Component],
  templateUrl: './outreach.component.html',
  styleUrl: './outreach.component.scss',
})
export class OutreachComponent extends DestroyBase implements OnInit {
  loading = false;
  uniqueId: string | null = null;
  isSubmitted = false;
  isExpired = false;
  isIdInvalid = false;
  formData!: OutreachFormData;
  connections: Connection[] = [];
  outreachFormType = OutreachFormType;
  isDemoMode = false;

  outreachService = inject(OutreachService);
  route = inject(ActivatedRoute);
  businessRecordUniqueId: string | null = null;

  ngOnInit(): void {
    this.route.paramMap.subscribe((params) => {
      if (this.route.snapshot.url[0].path === 'cdfi-outreach-demo') {
        this.isDemoMode = true;
        this.formData = {
          outreach_type: this.outreachFormType.PUBLIC,
        };
        this.loading = false;
        localStorage.removeItem('generalOutreachFormData');
        localStorage.removeItem('loanApplicationFormData');
        localStorage.removeItem('currentSection');
        localStorage.removeItem('section0Page');
        localStorage.removeItem('sectionHistory');
        localStorage.removeItem('formLanguage');
        localStorage.removeItem('formStartTime');
        localStorage.removeItem('formSnapshots');
        return;
      }

      this.uniqueId = params.get('id');
      this.businessRecordUniqueId = params.get('uniqueId');
      if (this.uniqueId === 'test-crf') {
        this.formData = {
          outreach_type: this.outreachFormType.CRF,
        };
      } else if (this.uniqueId === 'test-general') {
        this.formData = {
          outreach_type: this.outreachFormType.PUBLIC,
        };
      } else {
        if (this.uniqueId) {
          if (isValidGUID(this.uniqueId) || this.uniqueId === 'crm') {
            this.outreachService
              .getFormType(this.uniqueId, this.businessRecordUniqueId)
              .pipe(takeUntil(this.destroy$))
              .subscribe({
                next: (res) => {
                  this.formData = res.form_data;
                  this.uniqueId = res.form_data.form_id!;
                  if (
                    this.formData.outreach_type === OutreachFormType.CRF &&
                    res.connections !== null
                  ) {
                    this.connections = res.connections;
                  }
                  this.loading = false;
                },
                error: (error) => {
                  console.error('API response error:', error);
                  if (error.status === 409) {
                    this.isSubmitted = true;
                  } else if (error.status === 410) {
                    this.isExpired = true;
                  } else {
                    this.isIdInvalid = true;
                  }
                  this.loading = false;
                },
              });
          } else if (this.uniqueId === 'public') {
            this.formData = {
              outreach_type: this.outreachFormType.PUBLIC,
            };
            this.loading = false;
          } else {
            this.isIdInvalid = true;
            this.loading = false;
          }
        } else {
          this.isIdInvalid = true;
          this.loading = false;
        }
      }
    });
  }
}
